<div class="row g-sm-3 g-2">
  <div class="col-6 col-md-4">
    <div
      class="card-body balance-card widget-hover d-flex justify-content-between align-items-center h-100 rounded-4">
      <div class="d-flex flex-column">
        <div>
          <span class="fw-bold f-light">
            {{ 'transfer.balanceProfile' | translate }}
          </span>
          <h6 class="mt-1 mb-0">
            {{ currencyCodeProfile }} {{ balanceProfile | number: FORMAT_FOR_CURRENCY_DIGITS }}
          </h6>
        </div>
        <div class="mt-2">
          <span class="fw-bold f-light">
            {{ 'transfer.myCredit' | translate }}
          </span>

          <h6 class="mt-1 mb-0">
            {{ currencyCodeProfile }} {{ creditProfile | number: FORMAT_FOR_CURRENCY_DIGITS }}
          </h6>
        </div>
      </div>
      <div class="svg-box d-flex justify-content-center">
        <i class="fa fa-dollar fs-6 text-secondary"></i>
      </div>
    </div>
  </div>
  <div class="col-6 col-md-4">
    <div
      class="card-body balance-card widget-hover d-flex justify-content-between align-items-center h-100 rounded-4">
      <div class="d-flex flex-column">
        <div>
          <span class="fw-bold f-light">
            {{ 'transfer.myTotal' | translate }}
          </span>
          <h6 class="mt-1 mb-0">
            {{ currencyCodeProfile }}
            {{ totalBalanceProfile | number: FORMAT_FOR_CURRENCY_DIGITS }}
          </h6>
        </div>
        <div class="mt-2">
          <span class="fw-bold f-light">
            @if (isCreditAgent) {
              {{ 'transfer.total' | translate }}
              {{ 'transfer.agent' | translate | lowercase }}
              {{ 'tools.commissionPlans.commission' | translate | lowercase }}
            } @else {
              {{ 'transfer.total' | translate }} {{ cardTitle }}
            }
          </span>
          <h6 class="mt-1 mb-0">
            {{ currencyCode }} {{ totalBalanceAgent | number: FORMAT_FOR_CURRENCY_DIGITS }}
          </h6>
        </div>
      </div>
      <div class="svg-box d-flex justify-content-center">
        <i class="fa fa-money fs-6 text-secondary"></i>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <div
      class="card-body balance-card widget-hover d-flex justify-content-between align-items-center h-100 rounded-4">
      <div class="d-flex flex-column">
        <div>
          <span class="fw-bold f-light">
            {{ 'transfer.balance' | translate }} {{ cardTitle }}
          </span>
          <h6 class="mt-1 mb-0">
            {{ currencyCode }} {{ balance | number: FORMAT_FOR_CURRENCY_DIGITS }}
          </h6>
        </div>
        @if (selectedOption !== USER_TYPE.PLAYER) {
          <div class="mt-2">
            <span class="fw-bold f-light">
              {{ 'transfer.credit' | translate }} {{ cardTitle }}
            </span>
            <h6 class="mt-1 mb-0">
              {{ currencyCode }} {{ credit | number: FORMAT_FOR_CURRENCY_DIGITS }}
            </h6>
          </div>
        }
      </div>
      <div class="svg-box d-flex justify-content-center">
        <i [ngClass]="getIconClass()" class="fs-6 text-secondary"></i>
      </div>
    </div>
  </div>
</div>
